import { EVENTS } from '../utils/constants.js'
import publishUserData from '../applications/publishUserData.js'
import saveUserInLocalData from '../applications/saveUserInLocalData.js'
import getUserData from '../applications/getUserData.js'
import refreshUserData from '../applications/refreshUserData.js'

import InactivityTracker from '../utils/inactivityTracker.js'

class OnAppReady {
  static register(context) {
    context.events.handle(EVENTS.APP_READY, async payload => {
      try {
        if (InactivityTracker.checkAndEnforce(context)) {
          return
        }

        const userData = await getUserData(context)
        saveUserInLocalData(context, userData)
        if (userData) publishUserData(context)

        // Refresh user data from network to verify existence and admin role
        if (userData) {
          await refreshUserData(context)
        }
      } catch (error) {
        context.sendBugAlert(error)
      }
    })
  }
}
export default OnAppReady
